import moment from "moment";
import i18n from "../locale/languages";

var formattedDateTime = "dddd, MMMM Do, YYYY @ H:mm";
var formattedDate = "MMMM Do, YYYY";
var formattedShortDateWithoutYear = "D MMM";
var dateTimeFormat = "YYYY-MM-DDTHH:mm";
var dateTimePickerFormat = "YYYY-MM-DDTHH:mm";
var dateTimeAPIFormat = "YYYY-MM-DDTHH:mm";
var dateFormat = "YYYY-MM-DD";
var timeFormat = "HH:mm";

switch (document.querySelector("html").attributes["lang"].value) {
  case "nl-NL":
    i18n.locale = "nl";
    break;
  case "de":
    i18n.locale = "de";
    break;
  default:
    i18n.locale = "en";
    // test dutch
    //i18n.locale = "nl";
    break;
}
moment.locale(i18n.locale);

export default {
  methods: {
    getFormattedDateTime(val) {
      return moment(val).format(formattedDateTime);
    },
    getFormattedDate(val) {
      return moment(val).format(formattedDate);
    },
    getFormattedShortDateWithoutYear(val) {
      return moment(val).format(formattedShortDateWithoutYear);
    },
    getLocaleFormattedDateTime(val) {
      return moment(val).format(this.$t("dateTime.long"));
    },
    getLocaleFormattedDate(val) {
      return moment(val).format(this.$t("date.long"));
    },
    getDateTimeAPIFormat(date, time) {
      return moment(date).format(dateFormat) + " " + time;
    },
    minReservationDate() {
      return moment()
        .add(1, "days")
        .toDate();
    },
    minReservationReturnDate(val, minimalRentalDays) {
      if (minimalRentalDays) {
        return moment(val)
          .add(minimalRentalDays, "days")
          .toDate();
      } else {
        return this.minReservationDate();
      }
    },
    getJSDateObjectAsDate(val) {
      return moment(val);
    },
    getDateAsJSDateObject(val) {
      return moment(val).toDate();
    },
    getDateTimePickerFormat(val) {
      return moment(val).format(dateTimePickerFormat);
    },
    getDateTimeFormatByDateAndTime(date, time) {
      return `${moment(date).format("YYYY-M-D")}T${time}`;
    },
    getDateTimeFormat(val) {
      return moment(val).format(dateTimeFormat);
    },
    getDateFormat(val) {
      return moment(val).format(dateFormat);
    },
    getTimeFormat(val) {
      return moment(val).format(timeFormat);
    },
    setReservationDate(val) {
      return moment(val).getDate();
    },
    differenceBetweenDateTimesInHours(val1, val2) {
      return moment(val1).diff(moment(val2), "hours");
    },
    differenceBetweenDateTimesInYears(val1, val2) {
      return moment(val1).diff(moment(val2), "years");
    },
    getMonthName(val) {
      return moment.months(val-1)
    },
    getDay(val) {
      return moment(val).format('D')
    },
    getMonth(val) {
      return moment(val).format('M')
    },
    getYear(val) {
      return moment(val).format('Y')
    },
    getDateMinYears(years) {
      return moment().add(-years).toDate()
    }
  }
};
